import React from 'react';
import { Helmet } from 'react-helmet';

const packages = [
  {
    id: 1,
    title: 'Aura',
    location: '4 Seater - Comfortable Ride',
    seater: '4',
    price: 18,
    oldPrice: 20,
    image: '/images/ourfleet/6.jpg',
    link: 'destination-details.html',
  },
  {
    id: 2,
    title: 'Swift Desire',
    location: '4 Seater - Smooth and Stylish',
    seater: '4',
    price: 12,
    oldPrice: 15,
    image: '/images/ourfleet/8.jpg',
    link: 'destination-details.html',
  },
  {
    id: 3,
    title: 'Toyota Etion',
    location: '4 Seater - Compact and Efficient',
    seater: '4',
    price: 18,
    oldPrice: 20,
    image: '/images/ourfleet/7.jpg',
    link: 'destination-details.html',
  },
  {
    id: 4,
    title: 'Ertiga',
    location: '6 Seater - Family Comfort',
    seater: '6 + 1',
    price: 15,
    oldPrice: 18,
    image: '/images/ourfleet/4.jpg',
    link: 'destination-details.html',
  },
  {
    id: 5,
    title: 'Innova Crysta',
    location: '6 Seater - Premium Ride',
    seater: '6 + 1',
    price: 20,
    oldPrice: 25,
    image: '/images/ourfleet/3.jpg',
    link: 'destination-details.html',
  },
  {
    id: 6,
    title: 'Kia Carens',
    location: '6 Seater - Spacious and Luxurious',
    seater: '6 +1',
    price: 17,
    oldPrice: 20,
    image: '/images/ourfleet/1.jpg',
    link: 'destination-details.html',
  },
  {
    id: 7,
    title: 'Innova Cab',
    location: '6 Seater - Comfort for Groups',
    seater: '6 + 1',
    price: 18,
    oldPrice: 22,
    image: '/images/ourfleet/2.jpg',
    link: 'destination-details.html',
  },
 
  {
    id: 9,
    title: ' Fortuner',
    // location: '35 Seater - Premium Bus',
    seater: '7 ',
    price: "-",
    oldPrice: 0,
    image: '/images/ourfleet/11.webp',
    link: 'destination-details.html',
  },
  {
    id: 8,
    title: 'Tempo Traveller',
    location: '17 Seater - Group Travel',
    seater: '17 ',
    price: 25,
    oldPrice: 30,
    image: '/images/ourfleet/9.jpg',
    link: 'destination-details.html',
  },
  {
    id: 7,
    title: 'Urbania ',
    location: '6 Seater - Comfort for Groups',
    seater: '17 + 1',
    // price: 18,
    oldPrice: 22,
    image: '/images/keyword/62.jpg',
    link: 'destination-details.html',
  },
 


  {
    id: 8,
    title: 'Mini Bus ',
    location: '17 Seater - Group Travel',
    seater: '32 ',
    // price: 25,
    oldPrice: 30,
    image: '/images/ourfleet/10.webp',
    link: 'destination-details.html',
  },
  {
    id: 9,
    title: 'Luxury Bus',
    location: '35 Seater - Premium Bus',
    seater: '35 ',
    price: "-",
    oldPrice: 0,
    image: '/images/ourfleet/10.jpg',
    link: 'destination-details.html',
  },

];

const Booking = () => {
  const handleWhatsApp = (cabName) => {
    const message = `Hi, I am interested in booking the ${cabName}. Could you please provide more details?`;
    const phoneNumber = '917972733209';
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };


  const jsonData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Book a Cab - Mauli Cabs",
    "url": "https://www.maulicabs.in/booking",  // Replace with actual URL
    "description": "Book a cab with Mauli Cabs for a comfortable and reliable taxi service from Mumbai to Pune. Choose from Innova Crysta, Ertiga, and sedan options for one-way and round trip bookings."
  };
  
 
  
  return (
    <>

<Helmet>
    <title>Book a Cab | Mauli Cabs | Mumbai to Pune Taxi Booking</title>
    <meta
      name="description"
      content="Book your cab now with Mauli Cabs for a safe and comfortable ride between Mumbai and Pune. Choose from a range of vehicles like Innova Crysta, Ertiga, and sedans."
    />
    <meta
      name="keywords"
      content="book cab mumbai to pune, taxi booking mauli cabs, mauli cabs booking, innova crysta taxi booking, one way cab booking mumbai pune, round trip taxi mumbai pune, book a taxi online, mauli cabs reservation, book taxi for pune, online cab booking mauli"
    />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet>

      <section
        className="vs-breadcrumb"
        style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
      >
        
        <div className="container">
          <div className="row text-center">
            <div className="col-12">
              <div className="breadcrumb-content">
                <h1 className="breadcrumb-title">
                  Booking
                </h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="vs-tour-package style-3 bg-third-theme-14 space border">
        <img
          src="/img/icons/rope-clamps.png"
          alt="icon"
          className="swing tour-package-icon-1"
        />
        <img
          src="/img/icons/mountan.png"
          alt="icon"
          className="tour-package-icon-2"
        />

        <div className="container">
          <div className="row justify-content-between align-items-center">
            <div className="col-md-6 col-lg-6 col-xxl-5">
              {/* Additional Content */}
            </div>
          </div>

          <div className="row mt-4">
            {packages.map((pkg) => (
              <div className="col-md-6 col-lg-4 py-2" key={pkg.id}>
                <div
                  className="tour-package-box bg-white-color"
                  style={{
                    border: '2px solid #F7921F',
                    borderRadius: '10px',
                    overflow: 'hidden',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
                  }}
                >
                  <div className="tour-package-thumb">
                    <img src={pkg.image} alt={pkg.title} className="w-100" />
                  </div>
                  <div className="tour-package-content" style={{ padding: '20px' }}>
                    <h5
                      className="title line-clamp-2"
                      style={{ color: '#631D02', fontWeight: 'bold' }}
                    >
                      <a
                        href={pkg.link}
                        style={{ color: '#631D02', textDecoration: 'none' }}
                      >
                        {pkg.title}
                      </a>
                    </h5>
                    <p
                      style={{
                        color: '#666',
                        fontSize: '14px',
                        marginBottom: '10px',
                      }}
                    >
                      {/* {pkg.location} */}
                    </p>
                    <div className="pricing-container" style={{ marginBottom: '15px' }}>
                      <div className="package-time">
                        <div className="package-detail">
                          <span
                            className="package-label"
                            style={{ color: '#631D02' }}
                          >
                            Seater:
                          </span>
                          <span className="package-value">{pkg.seater}</span>
                        </div>
                        <div className="package-detail">
                          <span
                            className="package-label"
                            style={{ color: '#631D02' }}
                          >
                            Per Km:
                          </span>
                          <span
                            className="package-value"
                            style={{ color: '#F7921F', fontWeight: 'bold' }}
                          >
                            ₹{pkg.price}
                          </span>
                        </div>
                        <div className="package-detail">
                          <span
                            className="package-label"
                            style={{ color: '#631D02' }}
                          >
                            Extra Hr:
                          </span>
                          <span className="package-value">₹150</span>
                        </div>
                        <div className="package-detail">
                          <span
                            className="package-label"
                            style={{ color: '#631D02' }}
                          >
                            Night Halt:
                          </span>
                          <span className="package-value">₹250</span>
                        </div>
                      </div>
                    </div>
                    <button
                      onClick={() => handleWhatsApp(pkg.title)}
                      className="vs-btn style7 w-100"
                      style={{
                        backgroundColor: '#F7921F',
                        color: '#fff',
                        border: 'none',
                        padding: '10px 15px',
                        fontWeight: 'bold',
                        borderRadius: '5px',
                      }}
                    >
                      Book Now
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Booking;
